import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NotificationContainerComponent } from './notification-container/notification-container.component';
import { EventsTabComponent } from './events-tab/events-tab.component';
import { NewsTabComponent } from './news-tab/news-tab.component';
import { FcTabsModule } from '@fc-shared/ui/tabs';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { EmptyStateComponent } from '@fc-shared/ui/empty-state/empty-state.component';
import { ImageLoaderModule } from '@fc-shared/ui/image-loader/image-loader.module';
import { MatRippleModule } from '@angular/material/core';
import { SkeletonModule } from '@fc-shared/ui/skeleton/skeleton.module';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { ScrollNearEndDirective } from '@fc-shared/directives/scroll-near-end.directive';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { NgButtonComponent } from '@fc-shared/ui/buttons/ng-button';
import { IconComponent } from '@fc-shared/ui/icon/icon.component';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { StatusTagComponent } from '@fc-shared/ui/status-tag/status-tag.component';
import { EventItemComponent } from '@fc-core/notifications/events-tab/event-item.component';
import { EventListComponent } from '@fc-core/notifications/events-tab/event-list.component';

@NgModule({
  declarations: [NotificationContainerComponent, EventsTabComponent],
  imports: [
    CommonModule,
    FcTabsModule,
    MatIconModule,
    MatButtonModule,
    EmptyStateComponent,
    ImageLoaderModule,
    MatRippleModule,
    SkeletonModule,
    ScrollingModule,
    ScrollNearEndDirective,
    MatProgressSpinnerModule,
    NgButtonComponent,
    IconComponent,
    RouterLink,
    StatusTagComponent,
    RouterLinkActive,
    EventItemComponent,
    EventListComponent,
    NewsTabComponent,
  ],
  exports: [
    NotificationContainerComponent,
    NewsTabComponent,
    EventsTabComponent,
  ],
})
export class NotificationsModule {}
